// src/components/UsageBarChart.js
// Bar chart: usage by firma
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const UsageBarChart = ({ data }) => (
  <div className="bg-white rounded-lg shadow p-6 mb-6">
    <h2 className="text-lg font-semibold mb-2">Usage by Firma</h2>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="firma" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#10b981" name="Messages" />
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export default UsageBarChart;
